import { ArcadeUser } from '../types';
import { profanities } from './constants';

export const isNotWithinRange = (
  valLength: number,
  min: number,
  max: number
): boolean => valLength < min || valLength > max;

export const isLettersAndNumbersOnly = (inputValue: string) =>
  /^[a-zA-Z0-9]*$/.test(inputValue);

export const isNotProfane = (nickname: string): boolean =>
  profanities.split(',').every((word) => !nickname.includes(word));

export const getUserArcadeDobMonthDayYear = (userArcadeDob?: string) => {
  const extractedData = {
    birthMonth: '',
    birthDay: '',
    birthYear: '',
  };
  if (!userArcadeDob) {
    return extractedData;
  }
  const userArcadeDobArray = userArcadeDob.split('-');
  if (userArcadeDobArray.length === 3) {
    extractedData.birthMonth = userArcadeDobArray[1];
    extractedData.birthDay = userArcadeDobArray[2];
    extractedData.birthYear = userArcadeDobArray[0];
  }
  return extractedData;
};

export const hasCompletedArcadeProfile = (user?: ArcadeUser): boolean => {
  if (!user) return false;
  let isComplete = true;
  const userCountryCode = user.countryInfo?.country?.countryCode;
  // is country code provided?
  if (!userCountryCode) {
    isComplete = false;
  }
  // is country section complete?
  if (userCountryCode) {
    if (
      userCountryCode?.toLowerCase() === 'ca' &&
      !user.countryInfo?.province?.provinceCode
    ) {
      isComplete = false;
    }
  }
  // is birthday provided?
  if (!user.dob) {
    isComplete = false;
  }
  // is username provided?
  if (!user?.nickname) {
    isComplete = false;
  }
  return isComplete;
};
